import * as Sentry from '@sentry/nuxt';
import { HOME_URL, SENTRY_CLIENT_DNS } from '~/constants/config';
import { version } from './package.json';
import { IS_PRODUCTION } from '@devhacker/shared/config/env';

if (SENTRY_CLIENT_DNS && import.meta.env.VITE_SENTRY_ENABLED !== 'false') {
  Sentry.init({
    debug: HOME_URL.includes('localhost'),
    dsn: SENTRY_CLIENT_DNS,
    allowUrls: [/https?:\/\/(.*\.)?lifehacker\.ru/],
    release: version,
    sampleRate: IS_PRODUCTION ? 0.001 : 1,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false, // false т.к. мы итак отправляем крошки в логгере
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.extraErrorDataIntegration(),
    ],
    ignoreErrors: [
      // adfox ожидаемая ошибка
      'CONTAINER_IS_HIDDEN',
      // Проблемы с интернетов в рекламе
      'FedCM get() rejects with NetworkError',
      'FedCM get() rejects with AbortError',
    ],
  });
} else {
  console.warn(`SENTRY_CLIENT_DNS isn't provided`);
}
